<footer class="footer-position margin-top mt24" [ngClass]="{'fixed-footer':isFooterFixed}">
	<div class="footer-copyright">
    <ng-container *ngIf="hideMe === false">
      <mapfre-modal 
        [modalOptions]="footerHelpModalOptions"
        [hideModal]="hideModal"
        (hideModalOutput)="resetHideModal()">
        <label class="grid-modal-footer modal-footer margin-top mt16" for="English" [ngClass]="{'active': defaultLanguage === 'EN' }" mdbRipple>
          <div class="modal-content-footer">
            <input type="radio" class="modal-radio"  
            value="EN" id="English" name="languageCheckbox" 
            [checked]="defaultLanguage==='EN'" (click)="defaultLanguage='EN'">
            <span for="English" class="modal-footer-copy">ENGLISH</span>
          </div>
        </label>
        <label class="grid-modal-footer modal-footer" for="Spanish" [ngClass]="{'active': defaultLanguage === 'ES' }" mdbRipple>
          <div class="modal-content-footer">
              <input type="radio" class="modal-radio"  
              value="ES" id="Spanish" name="languageCheckbox" 
              [checked]="defaultLanguage==='ES'" (click)="defaultLanguage='ES'">
              <span for="Spanish" class="modal-footer-copy">ESPAÑOL</span>
          </div>
        </label>
        <div class="modal-footer">
          <div class="col">
            <mapfre-button
              [additionalClasses]="'basic primary large-btn'"
              (click)="switchUserLanguage(); hideModalAction($event)">
              {{'CONFIRM_LANGUAGE' | translate}}
            </mapfre-button>
          </div>
        </div>
        <div class="disclaimer disclaimer-small-size modal-body no-margin-bottom no-padding-bottom no-padding-top">
          <div class="margin-bottom mb16"><strong>English version:</strong> Translations of any website and customer portal content into languages other than English are intended solely as a convenience to the non-English-reading public and are not legally binding. The English version of all content, including our Terms & Conditions and Privacy Policy, is the definitive, legal version and will control in the event of any dispute, complaint or litigation.</div>
          <div class="margin-bottom mb24"><strong>En la versión en español: </strong> Del portal de Mapfre,  hemos traducido la informacion mas importante para ayudarte en la navegacion y uso de servicios, no obstante algunos servicios o documentos apareceran en ingles. La version ingles de MAPFRE Portal asi como los Terminos y Condiciones de uso, es la versión legal y definitiva.</div>
        </div>
      </mapfre-modal>
    </ng-container>
    <ng-container *ngIf="stateCode==='ACMIC'; else otherMAStateFtr">
      <div class="container ftr-container">
        <div class="flex">
          <span>&copy; {{ year }} {{ 'FOOTER_AUTO_CLUB' | translate }} </span>
          <span class="nowrap">{{ 'ALL_RIGHTS_RESERVED' | translate }}</span>
        </div>
        <div class="privacy-terms-conditions-links">
            <a target="_blank" href="https://wa.aaa.com/insurance/aaa-insurance/manage/ins-privacy-policy">Privacy Policy</a> 
            <span class="mr-2 ml-2">|</span>
            <a target="_blank" href="https://wa.aaa.com/insurance/aaainsurance/terms-conditions.html">Terms and Conditions</a>
        </div>
      </div>
    </ng-container>
    <ng-template #otherMAStateFtr>
        <div class="container ftr-container padding-top pt32">
          <div class="ftr-block">
            <div class="ftr-links-para">
              <div class="ftr-links">
                <a target="_blank" href="https://www.mapfreinsurance.com/en/privacy-policy/" class="dm-sans-medium">Privacy Policy</a>
                <!-- <span class="ml-2 mr-2"> | </span> -->
                <a target="_blank" href="https://www.mapfreinsurance.com/en/terms-conditions/" class="dm-sans-medium terms-and-conditions">Terms and Conditions</a>
                <ng-container *ngIf="stateCode !== 'ACMIC'">
                <!-- <span class="ml-2 mr-2"> | </span> -->
                <a target="_blank" href="https://www.mapfreinsurance.com/ccpa-request-form/" class="dm-sans-medium">CA Personal Data Request</a>
                </ng-container>
              </div>             
              <span class="copyright-para">
                &copy; {{ year }} {{ 'FOOTER_COPY_RIGHT' | translate }}
              </span>
            </div>
          </div>
        </div>
    </ng-template>
  </div>
</footer>